import {
  useCallback,
  useRef,
} from 'react';

export default function useStepTimingLogger(prefix: string) {
  const stepStartTimeRef = useRef(0);
  const stepEndTimeRef = useRef(0);
  const keyRef = useRef('');

  const start = useCallback((key: string, extra?: any) => {
    keyRef.current = key;
    stepStartTimeRef.current = performance.now();
    stepEndTimeRef.current = stepStartTimeRef.current;

    console.info(`[${prefix} ${keyRef.current}] start step=0.00s total=0.00s`, extra ?? '');
  }, [prefix]);

  const log = useCallback((step: string, extra?: any, isError: boolean = false) => {
    const now = performance.now();
    const stepSec = (now - stepEndTimeRef.current) / 1000;
    const totalSec = (now - stepStartTimeRef.current) / 1000;
    stepEndTimeRef.current = now;

    const logMessage = `[${prefix} ${keyRef.current}] ${step} step=${stepSec.toFixed(2)}s total=${totalSec.toFixed(2)}s`;
    if (isError) {
      console.error(logMessage, extra ?? '');
    } else {
      console.info(logMessage, extra ?? '');
    }
  }, [prefix]);

  const end = useCallback((extra?: any, isError: boolean = false) => {
    log('end', extra, isError);
    keyRef.current = '';
    stepStartTimeRef.current = 0;
    stepEndTimeRef.current = 0;
  }, [log]);

  return { start, log, end };
}
